import script from "./LoadingDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingDialog.vue?vue&type=script&setup=true&lang=js"

import "./LoadingDialog.vue?vue&type=style&index=0&id=9debb4ca&lang=css"

const __exports__ = script;

export default __exports__